export default __webpack_public_path__ + "static/media/clasical.ea016f7f.jpeg";